import React from "react";

const AllCampaigns = ({ color = "#000000", size = "20" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5 4.16602C17.5 5.54673 14.1421 6.66602 10 6.66602C5.85786 6.66602 2.5 5.54673 2.5 4.16602M17.5 4.16602C17.5 2.7853 14.1421 1.66602 10 1.66602C5.85786 1.66602 2.5 2.7853 2.5 4.16602M17.5 4.16602V15.8327C17.5 17.216 14.1667 18.3327 10 18.3327C5.83333 18.3327 2.5 17.216 2.5 15.8327V4.16602M17.5 9.99935C17.5 11.3827 14.1667 12.4993 10 12.4993C5.83333 12.4993 2.5 11.3827 2.5 9.99935"
        stroke={color}
        strokeWidth="1.5"
        stroke-linecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AllCampaigns;
